import { collection, query, where, getDocs } from 'firebase/firestore'
import { fs, fbStorage } from '../Services/firebase'

export function getReviews() {
  return new Promise((resolve, reject) => {
    fs.collection('reviews')
      .get()
      .then(querySnapshot => {
        let business = [];
        querySnapshot.forEach(doc => {
          business.push(doc.data())
        })
        resolve(business);
      })

  })
}

export function getReviewsByUserId(id) {
  return new Promise((resolve, reject) => {

    fs.collection('reviews')
      .where('userId', '==', id)
      .get()
      .then(querySnapshot => {
        let user = [];
        querySnapshot.forEach(doc => {
          user.push(doc.data())
        })
        resolve(user);
      })

  })
}

export function getReviewByBusinessId(businessId) {
  return new Promise((resolve, reject) => {
    fs.collection('reviews')
      .where('businessId', '==', businessId)
      .get()
      .then(querySnapshot => {
        let user = [];
        querySnapshot.forEach(doc => {
          user.push(doc.data())
        })
        resolve(user);
      })

  })
}

export function getReviewsCount() {
  return new Promise((resolve, reject) => {
    fs.collection('reviews')
      .get()
      .then(querySnapshot => {
        let reviewsList = [];
        querySnapshot.forEach(doc => {
          reviewsList.push(doc.data())
        })
        resolve(reviewsList);
      })

  })
}

export function addReview(businessData) {
  return new Promise((resolve, reject) => {
    let bizRef = fs.collection("reviews").doc();
    businessData.businessId = bizRef.id
    bizRef.set(businessData);
    resolve(businessData);
  })
}

export function editReview(businessData) {
  return new Promise((resolve, reject) => {
    let bizRef = fs.collection("reviews").doc(businessData.reviewId);
    // return bizRef.update(businessData)
    return bizRef.update({status:businessData.status})
      .then(() => {
        resolve('ok');
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });

  })
}

export function deleteReview(id) {
  return new Promise((resolve, reject) => {
    fs.collection("reviews").doc(id).delete().then(() => {
      resolve('ok');
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });

  })
}
